import { useCallback } from "react";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import { useSearchParamState } from "@/common/hooks/nuqs/useSearchParamState.ts";
import { useModalQueryState } from "@/common/hooks/nuqs/useModalQueryState.ts";
import useCurrentExplorerItemId from "@/common/hooks/useCurrentExplorerItemId.ts";
import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import useUserIsWriting from "@/common/hooks/useUserIsWriting.ts";

export const useKeyboardShortcutOpenTrackViewModal = (): void => {
  const userIsWriting = useUserIsWriting();
  const [modalIsOpen] = useSearchParamState(URLSearchParamKeys.MODAL);
  const { setModalParam: setTrackViewModalParam, unsetModalParam: unsetTrackViewModalParam } =
    useModalQueryState(URLSearchParamKeys.TRACK_VIEW_MODAL);
  const [currentExplorerItemId] = useCurrentExplorerItemId();

  const toggleTrackViewModal = useCallback((event: KeyboardEvent): void => {
    if (userIsWriting() || !currentExplorerItemId) return;

    event.preventDefault();
    
    if (modalIsOpen) {
      unsetTrackViewModalParam();
    } else {
      setTrackViewModalParam(currentExplorerItemId);
    }
  }, [
    userIsWriting,
    currentExplorerItemId,
    modalIsOpen,
    setTrackViewModalParam,
    unsetTrackViewModalParam
  ]);

  useKeyboardListener((event) => {
    if (event.key === "I" && event.shiftKey) {
      toggleTrackViewModal(event);
    }
  });
};
